import * as schemaScholarshipsDiscounts from './schemas/scholarshipsDiscounts';
import apiClient from './apiClient';
import { ScholarshipsDiscountsDataStore } from '../../datastores/ScholarshipsDiscountsDataStore';

class ScholarshipsDiscountsDataStoreGraphQL
  implements ScholarshipsDiscountsDataStore
{
  client = apiClient();

  async getScholarshipsDiscounts() {
    try {
      const response = await this.client.query({
        query: schemaScholarshipsDiscounts.getScholarshipsDiscounts
      });
      return response?.data?.scholarshipsDiscounts;
    } catch (error) {
      throw new Error(
        `Error fetching scholarshipsDiscounts: ${
          error instanceof Error ? error.message : String(error)
        }`
      );
    }
  }

  async getAgreementInfo(codigoTramite: number, dniEmpleado?: string) {
    try {
      const response = await this.client.query({
        query: schemaScholarshipsDiscounts.getAgreementInfo,
        variables: { codigoTramite, dniEmpleado }
      });
      return response?.data?.agreementInfo;
    } catch (error) {
      throw new Error(
        `Error fetching agreementInfo: ${
          error instanceof Error ? error.message : String(error)
        }`
      );
    }
  }

  async registerAgreement(input: any) {
    try {
      const response = await this.client.mutate({
        mutation: schemaScholarshipsDiscounts.registerAgreement,
        variables: { input }
      });
      return response?.data?.registerAgreement;
    } catch (error) {
      throw new Error(
        `Error registering agreement: ${
          error instanceof Error ? error.message : String(error)
        }`
      );
    }
  }
}

export default ScholarshipsDiscountsDataStoreGraphQL;
